import styled from 'styled-components';
import { Tooltip } from 'antd';

export const MainTooltip = styled(Tooltip)`
`;
